import React from 'react';
import {injectIntl, IntlProvider} from 'react-intl';
import { connect } from 'react-redux';
import {Row, Col, OverlayTrigger, Popover, Badge, Button} from 'react-bootstrap';
import { getTextColor } from 'components/forms/autocomplete/Color';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';
import FormLangInput from 'components/forms/FormLangInput';

import {SketchPicker} from "react-color";
import FormSwitchery from "../../forms/FormSwitchery";
import FormFolder from "../../forms/FormFolder";
import {getThumbFileFromEntity} from "helpers/items";
import FormImageWithPreview from "components/forms/FormImageWithPreview";
import {formStatusDispatchHelper} from "actions/FormStatusActions";
import {addNotification} from "actions/NotificationsActions";
import { isObject as _isObject } from 'lodash';

class ClientCorporateDesign extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      files: [],

    };
  }
  // Todo componentdidupdate
  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatusClientMainLogo,
      doNotify,
      entity
    } = this.props;

    const fileUploadedMessage = messages.file_uploaded;

    if (prevProps.formStatusClientMainLogo.pending && !formStatusClientMainLogo.pending && !formStatusClientMainLogo.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('clientMainLogo', [], formStatusClientMainLogo.response);
      this.updateEntity('clientMainLogo', value, [], null, false);

      doNotify(1, fileUploadedMessage);
    }
  }

  // Todo fileupload
  fileUpload = (name, images) => {
    const { clientId } = this.props
    if (_isObject(images) && images.length === 1) {
      const fd = new FormData();
      fd.append('file', images[0]);
      fd.append('logoType', name);

      switch (name) {
        case 'clientMainLogo':
          this.props.uploadClientMainLogo(clientId, fd);
          break;
      }
    }
  };

  fileReset = name => {
    this.updateEntity(name, null);
  };

  updateContext = () => {
    const { clientId } = this.props;
    this.props.updateUploadContext({
      type: 'client_assets',
      clientId,
      uploadLink: `/api/clienttemplates/${clientId}.json`,
    });
  }
  removeFontColor = index => {
    const { entity } = this.props;
    const fontColors = entity.getFontColors().slice();
    fontColors.splice(index, 1);
    this.updateEntity('fontColors', fontColors);
  };

  addFontColor = () => {
    const { entity } = this.props;
    const fontColors = entity.getFontColors().slice();
    fontColors.push(
      entity.createValue('fontColors', [], { label: [{lang: 'de', name: 'Color ' + (fontColors.length + 1)}], color: '#000000' })
    );
    this.updateEntity('fontColors', fontColors);
  };

  editFontColor = (index, propertyName, propertyValue) => {
    this.updateEntity(propertyName, propertyValue, ['fontColors', index.toString()]);
  };

  removeBackColor = index => {
    const { entity } = this.props;
    const backColors = entity.getBackColors().slice();
    backColors.splice(index, 1);
    this.updateEntity('backColors', backColors);
  };

  addBackColor = () => {
    const { entity } = this.props;
    const backColors = entity.getBackColors().slice();
    backColors.push(
      entity.createValue('backColors', [], { label: [{lang: 'de', name: 'Color ' + (backColors.length + 1)}], color: '#000000' })
    );
    this.updateEntity('backColors', backColors);
  };

  editBackColor = (index, propertyName, propertyValue) => {
    this.updateEntity(propertyName, propertyValue, ['backColors', index.toString()]);
  };

  removeFont = index => {
    const { entity } = this.props;
    const fonts = entity.getFonts().slice();
    fonts.splice(index, 1);
    this.updateEntity('fonts', fonts);
  };

  addFont = () => {
    const { entity } = this.props;
    const fonts = entity.getFonts().slice();
    fonts.push(
      entity.createValue('fonts', [], {
        label: 'Font ' + (fonts.length + 1),
        cssPath: 'Font',
        fileName: 'filename.woff',
        forUser: true,
        fontStyle: '',
        fontWeight: '',
      })
    );
    this.updateEntity('fonts', fonts);
  };

  editFont = (index, propertyName, propertyValue) => {
    this.updateEntity(propertyName, propertyValue, ['fonts', index.toString()]);
  };

  import = () => {
    const {files} = this.state;
    this.props.upload(files);
  }

  render() {
    const {
      intl: { messages },
      intl,
      entity,
      entityLoaded,
      disabled,
      inModal,
      upload,
      uploading,
    } = this.props;

    let mainLogoUrl; // Todo vars

  if (entityLoaded) {
    if (entity.getClientMainLogo().getId()) {
      const thumbnail = getThumbFileFromEntity(entity.getClientMainLogo());
      if (thumbnail) {
        mainLogoUrl = thumbnail.getWebLink();
      }
    }
  }


    return (
      <div class="clearfix">
        {entityLoaded ? (
          <div>
            <Row>
              <Col xs={12} md={12}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <h4>{messages.client_logo}</h4>
                    <div>
                      <FormImageWithPreview
                        label="Logo"
                        name="clientMainLogo"
                        url={mainLogoUrl}
                        onChange={this.fileUpload}
                        onReset={this.fileReset}
                        pending={this.props.formStatusClientMainLogo.pending}
                        disabled={disabled}
                      />
                    </div>
                    <h4>{messages.font_colors}</h4>
                    <div className="form-group-attached">
                      {entity.getFontColors().map((fontColor, i) => {
                        return (
                          <Row class="clearfix" key={i}>
                            <Col xs={5}>
                              <FormLangInput
                                label={messages.name}
                                name="label"
                                value={fontColor.getLabel()}
                                meta={fontColor.getLabelMetaInformation()}
                                validation={fontColor.getLabelValidationResult()}
                                onChange={(name, value) => this.editFontColor(i, name, value)}
                                disabled={disabled}
                              />
                            </Col>
                            <Col xs={5}>
                              <div className="form-group form-group-default" style={{position: 'relative'}}>
                                <label>{messages.color}</label>
                                <div style={{position: 'relative', width: '100%'}}>
                                  <OverlayTrigger
                                    trigger="click"
                                    rootClose
                                    placement="top"
                                    overlay={
                                      <Popover class="popover-modal">
                                        <IntlProvider locale={intl.locale} messages={intl.messages}>
                                          <SketchPicker
                                            disableAlpha
                                            onChange={({hex}) => this.editFontColor(i, 'color', hex)}
                                            color={fontColor.getColor()}
                                          />
                                        </IntlProvider>
                                      </Popover>
                                    }
                                  >
                                    <Badge
                                      style={{
                                        background: fontColor.getColor(),
                                        color: getTextColor(fontColor.getColor()),
                                      }}
                                      class="p-l-10 p-r-10 p-t-5 p-b-5 lh-15"
                                    >
                                      {fontColor.getColor()}
                                    </Badge>
                                  </OverlayTrigger>
                                </div>
                              </div>
                            </Col>
                            <Col xs={2}>
                              <div className="form-group form-group-default" style={{position: 'relative'}}>
                                <label>&nbsp;</label>
                                <Button bsSize="xs" class="btn-rounded" onClick={() => this.removeFontColor(i)}>
                                  <i className="fa fa-minus"/>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </div>
                    <div className="text-center p-t-15">
                      <Button class="btn-rounded" onClick={this.addFontColor}>
                        <i className="fa fa-plus"/>
                      </Button>
                    </div>

                    <h4>{messages.back_colors}</h4>
                    <div className="form-group-attached">
                      {entity.getBackColors().map((backColor, i) => {
                        return (
                          <Row class="clearfix" key={i}>
                            <Col xs={5}>
                              <FormLangInput
                                label={messages.name}
                                name="label"
                                value={backColor.getLabel()}
                                meta={backColor.getLabelMetaInformation()}
                                validation={backColor.getLabelValidationResult()}
                                onChange={(name, value) => this.editBackColor(i, name, value)}
                                disabled={disabled}
                              />
                            </Col>
                            <Col xs={5}>
                              <div className="form-group form-group-default" style={{position: 'relative'}}>
                                <label>{messages.color}</label>
                                <div style={{position: 'relative', width: '100%'}}>
                                  <OverlayTrigger
                                    trigger="click"
                                    rootClose
                                    placement="top"
                                    overlay={
                                      <Popover class="popover-modal">
                                        <IntlProvider locale={intl.locale} messages={intl.messages}>
                                          <SketchPicker
                                            disableAlpha
                                            onChange={({hex}) => this.editBackColor(i, 'color', hex)}
                                            color={backColor.getColor()}
                                          />
                                        </IntlProvider>
                                      </Popover>
                                    }
                                  >
                                    <Badge
                                      style={{
                                        background: backColor.getColor(),
                                        color: getTextColor(backColor.getColor()),
                                      }}
                                      class="p-l-10 p-r-10 p-t-5 p-b-5 lh-15"
                                    >
                                      {backColor.getColor()}
                                    </Badge>
                                  </OverlayTrigger>
                                </div>
                              </div>
                            </Col>
                            <Col xs={2}>
                              <div className="form-group form-group-default" style={{position: 'relative'}}>
                                <label>&nbsp;</label>
                                <Button bsSize="xs" class="btn-rounded" onClick={() => this.removeBackColor(i)}>
                                  <i className="fa fa-minus"/>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </div>

                    <div className="text-center p-t-15">
                      <Button class="btn-rounded" onClick={this.addBackColor}>
                        <i className="fa fa-plus"/>
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row class="clearfix">
              <Col xs={12} md={12}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <div className="form-group-attached">
                      <Row class="clearfix">
                        <Col xs={12} md={12}>
                          <h4>{messages.template_fonts}</h4>
                          <div className="form-group-attached">
                            {entity.getFonts().map((font, i) => {
                              return (
                                <Row class="clearfix" key={i}>
                                  <Col xs={3}>
                                    <FormInput
                                      label={messages.name}
                                      name="label"
                                      value={font.getLabel()}
                                      meta={font.getLabelMetaInformation()}
                                      validation={font.getLabelValidationResult()}
                                      onChange={(name, value) => this.editFont(i, name, value)}
                                      disabled={disabled}
                                    />
                                  </Col>
                                  <Col xs={2}>
                                    <FormInput
                                      label="CSS Name"
                                      name="cssPath"
                                      value={font.getCssPath()}
                                      meta={font.getCssPathMetaInformation()}
                                      validation={font.getCssPathValidationResult()}
                                      onChange={(name, value) => this.editFont(i, name, value)}
                                      disabled={disabled}
                                    />
                                  </Col>
                                  <Col xs={2}>
                                    <FormInput
                                      label="Dateiname"
                                      name="fileName"
                                      value={font.getFileName()}
                                      meta={font.getFileNameMetaInformation()}
                                      validation={font.getFileNameValidationResult()}
                                      onChange={(name, value) => this.editFont(i, name, value)}
                                      disabled={disabled}
                                    />
                                  </Col>
                                  <Col xs={1}>
                                    <FormInput
                                      label="Font Style"
                                      infoText="italic, oblique, ..."
                                      name="fontStyle"
                                      value={font.getFontStyle()}
                                      meta={font.getFontStyleMetaInformation()}
                                      validation={font.getFontStyleValidationResult()}
                                      onChange={(name, value) => this.editFont(i, name, value)}
                                      disabled={disabled}
                                    />
                                  </Col>
                                  <Col xs={1}>
                                    <FormInput
                                      label="Font Weight"
                                      infoText="400, 500, 600, ..."
                                      name="fontWeight"
                                      value={font.getFontWeight()}
                                      meta={font.getFontWeightMetaInformation()}
                                      validation={font.getFontWeightValidationResult()}
                                      onChange={(name, value) => this.editFont(i, name, value)}
                                      disabled={disabled}
                                    />
                                  </Col>
                                  <Col xs={2}>
                                    <div className="form-group form-group-default " style={{height: '58px'}}>
                                      <FormSwitchery
                                        name="forUser"
                                        label="Für Nutzer"
                                        infoText="User kann diesen Font im Editor verwenden"
                                        value={true}
                                        checked={font.getForUser()}
                                        onChange={(name, value) => this.editFont(i, name, value)}
                                        disabled={disabled}
                                      />
                                    </div>
                                  </Col>
                                  <Col xs={1}>
                                    <div className="form-group form-group-default" style={{position: 'relative'}}>
                                      <label>&nbsp;</label>
                                      <Button bsSize="xs" class="btn-rounded" onClick={() => this.removeFont(i)}>
                                        <i className="fa fa-minus"/>
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              )
                            })}
                          </div>
                          <div className="text-center p-t-15">
                            <Button class="btn-rounded" onClick={this.addFont}>
                              <i className="fa fa-plus"/>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <h3>Upload files to template folder</h3>
                    <FormFolder
                      label={messages.template_import_select_template}
                      name="file"
                      onChange={(fieldName, files) => {
                        this.setState({ files: files });
                        this.updateContext();
                      }}
                    />
                    <Button bsStyle="info" onClick={this.import}><i className={'fas ' + (uploading ? 'fa-circle-notch fa-spin' : 'fa-upload')}/> Upload</Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}
ClientCorporateDesign.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    formStatusClientMainLogo: state.formStatus.clientMainLogo, //todo props
    appIntl: state.intl,
    meta: state.entityMeta,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    uploadClientMainLogo: (clientId, args) => {
      formStatusDispatchHelper(
        'clientMainLogo',
        '/api/clients/' + clientId + '/logos.json', //todo api
        args,
        'post',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
}
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ClientCorporateDesign));
